<template>
  <div>
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('infoBatchTypeText', 'infoBatchTypeText') }}</h6>
					<b-button variant="dark" class="mb-2" @click="goBack()">{{ t('backButtonText', 'backButtonText')}}</b-button>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-info">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">Batch Type Details</h5>
                      <div class="element-inner-desc">Here you can see the details of the batch types</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
						<div class="col-sm-12 col-md-12 col-lg-3">
							<div class="table-responsive">
								<table class="table table-striped">
									<thead>
										<tr>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(value, propertyName, index) in getBatchType" v-if="index <= rowsShowing">
											<th scope="row">{{propertyName}}</th>
											<td>{{value}}</td>
										</tr>
									</tbody>
								</table>							
							</div>
							<b-button v-if="rowsShowing == 5" variant="secondary" @click="rowsShowing = Object.keys(getBatchType).length">Show More</b-button>
							<b-button v-if="rowsShowing == Object.keys(getBatchType).length" variant="secondary" @click="rowsShowing = 5">Show Less</b-button>
						</div>
					</div>
				</div>
			</div>
		</div>		
	</div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo'
import { mapGetters } from 'vuex'

export default {
	name: 'InfoBatchType',
	data() {
		return {
			rowsShowing: 5,
		}
	},
	components:{
		ResponseInfo
	},
	created() {
		this.$store.dispatch('coreTypesStore/getBatchTypeById', this.$route.query.id)
	},
	methods: {
		goBack() {
			this.$router.go(-1)
		}    
	},
	computed: {
		...mapGetters('coreTypesStore' ,['getBatchType']),
		...mapGetters(['getResponseInfo'])
	},
}
</script>

<style scoped>

</style>